/* iter-studio-dashboard-3 — Bible Field Focus listener.
 *
 * Listens once, at app-shell mount, for `pw-focus-bible-field` window
 * events. Each event carries `{ field: "character.wound" }`. The
 * listener walks the DOM for a matching `[data-bible-field="<key>"]`
 * element (an input, textarea, select, or wrapper). If found it
 * scrolls into view, focuses (if focusable), and momentarily adds a
 * gold ring so the writer can see WHICH field to fill. If the target
 * isn't mounted (Bible panel closed), the caller's toast already
 * routed the writer to open the right panel.
 */
const HIGHLIGHT_CLASS = 'pw-bible-focus-ring';
const HIGHLIGHT_MS = 2600;

let installed = false;

function inject() {
  if (document.getElementById('pw-bible-focus-style')) return;
  const s = document.createElement('style');
  s.id = 'pw-bible-focus-style';
  s.textContent = `
    .${HIGHLIGHT_CLASS} {
      outline: 3px solid rgba(219, 178, 90, 0.95);
      outline-offset: 3px;
      border-radius: 4px;
      transition: outline-color .25s ease, box-shadow .25s ease;
      box-shadow: 0 0 0 4px rgba(219, 178, 90, 0.18);
      animation: pw-bible-focus-pulse 1.4s ease-in-out 0s 2;
    }
    @keyframes pw-bible-focus-pulse {
      0%   { box-shadow: 0 0 0 4px rgba(219, 178, 90, 0.28); }
      50%  { box-shadow: 0 0 0 10px rgba(219, 178, 90, 0.06); }
      100% { box-shadow: 0 0 0 4px rgba(219, 178, 90, 0.28); }
    }
  `;
  document.head.appendChild(s);
}

function focusField(key) {
  if (!key) return false;
  const el = document.querySelector(`[data-bible-field="${CSS.escape(key)}"]`);
  if (!el) return false;
  try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  catch { /* older browsers */ }
  // Focus the underlying input if the anchor is a wrapper.
  const focusTarget =
    el.matches('input, textarea, select') ? el
    : (el.querySelector('input, textarea, select') || el);
  try {
    focusTarget.focus({ preventScroll: true });
  } catch { /* ignore */ }
  el.classList.add(HIGHLIGHT_CLASS);
  window.setTimeout(() => el.classList.remove(HIGHLIGHT_CLASS), HIGHLIGHT_MS);
  return true;
}

export function installBibleFieldFocus() {
  if (installed) return;
  installed = true;
  inject();
  const onEvent = (e) => {
    const key = e?.detail?.field;
    if (!key) return;
    // Retry once after the next paint — panels sometimes mount just
    // after the toast fires (e.g. drawer opens on click).
    if (!focusField(key)) {
      window.setTimeout(() => focusField(key), 350);
    }
  };
  window.addEventListener('pw-focus-bible-field', onEvent);
}
